import { HubConnectionState, type HubConnection } from "@microsoft/signalr";

/**
 * Invokes a hub method only if the connection is still live. Group
 * membership dies with the connection (see PatientAR-SignalR-contract.md),
 * so a Leave call has nothing to do once it has already dropped — skipping
 * it avoids both a pointless call and the "not in the 'Connected' State"
 * warning that invoking on a dead connection would otherwise log.
 */
export function invokeIfConnected(
  connection: HubConnection,
  methodName: string,
  ...args: unknown[]
): void {
  if (connection.state !== HubConnectionState.Connected) return;

  void connection.invoke(methodName, ...args).catch((err: unknown) => {
    console.warn(`[SignalR] Failed to invoke ${methodName}:`, err);
  });
}
